import React from 'react';
import { type NextRouter as Router } from '../stubs/next-types';
import { Outlet, createRootRoute } from '@tanstack/react-router';

import App from '../pages/_app';

const SyntheticRouter = {} as Router;

const TSRApp = () => <App Component={Outlet} pageProps={{}} router={SyntheticRouter} />;

export const Route = createRootRoute({
  component: TSRApp
});
